import { LookBook } from '@epicuro-next/models/engagement';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { createLookBookSuccess } from '../create/create-shop-the-look.actions';
import {
  deleteLookBookSuccess,
  editLookBookSuccess,
} from '../edit/edit-shop-the-look-actions';
import { updateLookBookNewsFeedId } from '../news-feed/news-feed.actions';
import { lookBooksUpdateDateCompare, mapLookbookMediaEntities } from '../utils';

import {
  loadLookBooks,
  loadLookBooksError,
  loadLookBooksSuccess,
  resetLookBooks,
  updateLookBookItemMedia,
} from './shop-the-looks-actions';

export interface ShopTheLooksState extends EntityState<LookBook> {
  loading: boolean;
  error?: string;
  page: number;
  size?: number;
  total: number;
}

/** State adapter */
export const adapter: EntityAdapter<LookBook> = createEntityAdapter<LookBook>({
  sortComparer: lookBooksUpdateDateCompare,
});

export const initial: ShopTheLooksState = adapter.getInitialState({
  loading: false,
  page: 1,
  size: 10,
  total: 0,
});

export const shopTheLooksReducer = createReducer<ShopTheLooksState>(
  initial,
  on(loadLookBooks, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(loadLookBooksSuccess, (state, action) => {
    return adapter.upsertMany(action.lookBooks, {
      ...state,
      page: state.page + 1,
      total: action.total,
      loading: false,
    });
  }),
  on(loadLookBooksError, (state, { error }) => ({
    ...state,
    lookBook: undefined,
    error,
    loading: false,
  })),
  on(resetLookBooks, (state) => adapter.removeAll({ ...state, page: 1 })),
  on(createLookBookSuccess, (state, action) => {
    return adapter.addOne(action.lookBook, {
      ...state,
      total: state.total + 1,
    });
  }),
  on(editLookBookSuccess, (state, action) => {
    return adapter.upsertOne(action.lookBook, {
      ...state,
    });
  }),
  on(updateLookBookNewsFeedId, (state, action) => {
    return adapter.updateOne(
      {
        id: action.lookBookId as string,
        changes: {
          newsfeedId: action.newsfeedId,
        },
      },
      state,
    );
  }),
  on(deleteLookBookSuccess, (state, action) => {
    return adapter.removeOne(action.lookBookId, {
      ...state,
      total: state.total - 1,
    });
  }),
  on(updateLookBookItemMedia, (state, { listId, media }) => {
    const entities = mapLookbookMediaEntities(state.entities, listId, media);
    return adapter.upsertMany(entities, state);
  }),
);
